import { render, staticRenderFns } from "./DNSBindingList.vue?vue&type=template&id=10a9091e&"
import script from "./DNSBindingList.vue?vue&type=script&lang=js&"
export * from "./DNSBindingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports